<div class="pb-1 parent">
  <div class="titlebar">
    <div class="pb-2">
      <div class="title">{{ title }}</div>
      <div class="subtitle">
        @if (showMaxCount) {
          <span>
            {{ selectedContacts.length }} of {{ maxCapacity }} {{ salutation }}s
            selected
          </span>
        }
        @if (!showMaxCount) {
          <span>
            {{ selectedContacts.length }} participant{{
              selectedContacts.length === 1 ? "" : "s"
            }}
            selected
          </span>
        }
      </div>
      @if (showAddParticipantsButton) {
        <div
          matRipple
          class="subbutton celo-hoverable"
          (click)="editParticipants.emit()"
        >
          <button mat-icon-button>
            <i class="material-icons">edit</i>
          </button>
          <span>Add Participants</span>
        </div>
      }
    </div>
  </div>
  <div class="list_content">
    <div>
      @for (contact of selectedContacts; track contact) {
        <div
          class="chip celo-hoverable"
          (click)="removable ? checkAndRemove(contact) : ''"
        >
          <div class="avatar">
            <app-avatar
              [name]="contact.firstName + ' ' + contact.lastName"
              [userId]="contact.userId"
              [width]="40"
              [height]="40"
              [hasImage]="!!contact.profilePic || !!contact.profilePicture"
              [picUrl]="contact.profilePic"
            ></app-avatar>
          </div>
          <div class="chip-name celo-elipsis">
            @if (!replaceMyName) {
              <span>{{ contact.firstName }} {{ contact.lastName }}</span>
            }
            @if (replaceMyName) {
              <span>
                @if (contact.userId === loggedInUserId) {
                  <span>{{ replaceMyName }}</span>
                }
                @if (contact.userId !== loggedInUserId) {
                  <span>{{ contact.firstName }} {{ contact.lastName }}</span>
                }
              </span>
            }
          </div>
          @if (!contact.disableRemove && removable) {
            <div class="close-button">
              <i class="material-icons">cancel</i>
            </div>
          }
        </div>
      }
      <div #bottom id="bottom"></div>
    </div>
    <div>
      @if (selectedContacts.length === 0) {
        <div class="empty_message">
          <div class="message">
            {{ empty_message }}
          </div>
        </div>
      }
    </div>
  </div>
</div>
